import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useUIStore = create()(
  persist(
    (set) => ({
      activeTab: 0,
      isDrawerOpen: false,
      setActiveTab: (index) => set({ activeTab: index }),
      setDrawerOpen: (open) => set({ isDrawerOpen: open }),
      toggleDrawer: () => set((state) => ({ isDrawerOpen: !state.isDrawerOpen })),
    }),
    {
      name: 'ui-storage',
    }
  )
);
